<template>
  <div></div>
</template>

<script>
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

export default {
  name: "ExcelComponent",
  props: {
    patient: Object,
    facescan_id: Number,
    landmark_id: Number,
    scanDate: String,
    imagingModality: String,
    pflAnalysisResult: Object,
    MandibleArc: Number,
    MaxillaryArc: Number,
    classificationMeans: Object,
    errors: Object,
  },
  data() {
    return {
      age: null,
    };
  },
  methods: {
    async calculateAndSetAge() {
      const fasdBackendURL =
        localStorage.getItem("fasdBackendURL") || "http://localhost:8000";
      const token = localStorage.getItem("userJWtoken");

      const response = await fetch(
        `${fasdBackendURL}/api/facescans/patientAge/${this.facescan_id}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const age = await response.json();
      this.age = parseFloat(age).toFixed(1);
    },

    async generateExcel() {
      const wb = new ExcelJS.Workbook();
      const ws = wb.addWorksheet("Summary");

      ws.columns = [
        { header: "Subject ID", key: "patient_identifier", width: 20 },
        { header: "Name", key: "name", width: 20 },
        { header: "Sex", key: "sex", width: 10 },
        { header: "Ethnicity", key: "ethnicity", width: 15 },
        { header: "dob", key: "dob", width: 15 },
        { header: "Age", key: "age", width: 12 },
        { header: "ScanDate", key: "scanDate", width: 15 },
        { header: "Imaging Modality", key: "imagingModality", width: 20 },
        { header: "PFL", key: "pfl", width: 10 },
        { header: "PFL Z-Score", key: "pflZ", width: 12 },
        { header: "PFL Percentile", key: "pflPct", width: 15 },
        { header: "MandibleArc", key: "Mandible", width: 15 },
        { header: "MaxillaryArc", key: "Maxillary", width: 15 },
        { header: "Face MeanError", key: "face", width: 15 },
        { header: "Malar MeanError", key: "malar", width: 15 },
        { header: "Philtrum MeanError", key: "philtrum", width: 15 },
        { header: "Mouth MeanError", key: "mouth", width: 15 },
      ];

      ws.addRow({
        patient_identifier: this.patient?.patient_identifier ?? "N/A",
        name: `${this.patient?.name || ""} ${this.patient?.surname || ""}`,
        sex: this.patient?.sex ?? "N/A",
        ethnicity: this.patient?.ethnicity ?? "N/A",
        dob: this.patient?.dob ?? "N/A",
        age: this.age ? `${this.age}` : "N/A",
        scanDate: this.scanDate ?? "N/A",
        imagingModality: this.imagingModality ?? "N/A",
        pfl: this.pflAnalysisResult?.PFL || "N/A",
        pflZ: this.pflAnalysisResult?.PFLzScore || "N/A",
        pflPct: this.pflAnalysisResult?.PFLpercentile || "N/A",
        Mandible: this.MandibleArc ?? "N/A",
        Maxillary: this.MaxillaryArc ?? "N/A",
        face: this.classificationMeans?.FACE ?? "N/A",
        malar: this.classificationMeans?.MALAR ?? "N/A",
        philtrum: this.classificationMeans?.PHILTRUM ?? "N/A",
        mouth: this.classificationMeans?.MOUTH ?? "N/A",
      });

      //Get XLSX buffer and make a Blob
      const buffer = await wb.xlsx.writeBuffer();
      const filename = `Report_${this.patient?.patient_identifier || "patient"}.xlsx`;
      const excelBlob = new Blob([buffer], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",});

      // Download for user 
      saveAs(excelBlob, filename);

      // Save Excel in DB
      try {
        await this.uploadExcelToBackend(excelBlob, filename);
      } catch (err) {
        console.error("Excel upload failed:", err);
      }
    },

    async uploadExcelToBackend(fileBlob, filename) {
      const fasdBackendURL =
        localStorage.getItem("fasdBackendURL") || "http://localhost:8000";
      const token = localStorage.getItem("userJWtoken");

      const formData = new FormData();
      formData.append("fasdreportfile", fileBlob, filename);
      formData.append("format", "XLSX"); 

      const url = `${fasdBackendURL}/api/fasdReports/${this.landmark_id}?format=XLSX`;

      const response = await fetch(url, {
        method: "POST",
        headers: { Authorization: `Bearer ${token}` }, 
        body: formData,
      });

         if (!response.ok) {
          throw new Error(`Failed to upload Excel file. Status: ${response.status}`);
        }
    },
  },
  mounted() {
    this.calculateAndSetAge();
  },
};
</script>
